import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { api } from '@services/apiClient'

import { mockedSiteSettings } from './mocks/settings'
import { useFindProfile } from './profile'

interface IEpsNode {
  code: string
  isIncluded: boolean
  id: number
  createdOn: Date
}
interface ISite {
  id: number
  code: string
  name: string
  timeZoneName: string
  country: string
  region: string
  shiftStartTime: number
  shiftEndTime: number
  startOfWeek: 0 | 2 | 1 | 3 | 4 | 5 | 6 | undefined
  utcOffset: number
  dateFormat: number
  timeFormat: number
  epsNodes: IEpsNode[]
  createdOn: Date
}

interface IFeatureSetting {
  key: string
  description: string
  defaultValue: string
  valueType: string
  inputType: string
  options: string
  featureFlagId: number
  category: string
}

interface IFeatureSettingsValue {
  id: number
  key: string
  value: string
}

interface IFeatureToggle {
  featureFlagId: number
  category: string
  description: string
  isActive: boolean
  featureSettings: IFeatureSetting[]
  featureSettingsValues: IFeatureSettingsValue[]
  key: string
  isEnabled: boolean
}

interface ISettings {
  site: ISite
  featureToggles: IFeatureToggle[]
  updatedBy: string
  updatedOn: Date
}

export function useFindSettings() {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const ONE_HOUR = 1000 * 60 * 60

  const siteId = user && user.selectedSite?.id

  async function fetchSettings() {
    if (!isMockEnvironment) {
      const { data } = await api.get<ISettings>(`sites/${siteId}/settings`)
      return data
    }

    return mockedSiteSettings
  }

  return useQuery({
    queryFn: fetchSettings,
    queryKey: ['SITE_SETTINGS'],
    staleTime: ONE_HOUR,
    enabled: !!siteId,
  })
}
